<template>
  <transition name="pop">
    <div class="unit-checkbox-card__elective-popup" v-if="isActive && !dismissed">
      <div class="unit-checkbox-card__elective-popup-content">
        <i class="far fa-info-circle"></i> This selection requires you to choose electives
      </div>
      <div class="unit-checkbox-card__elective-popup-actions">
        <button class="btn-link-bold-teal" v-on:click="scrollToElective(`anchor-${anchorCode}-1`)" type="button">See options</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SlideOutRelationshipElectiveAlert',
  props: {
    anchorCode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isActive: false,
      dismissed: false
    }
  },
  methods: {
    dismiss() {
      this.dismissed = true
    },
    scrollToElective(id) {
      var electiveContainer = document.getElementById(id).offsetTop
      document.getElementById('slideOutBodyTree').scrollTop = electiveContainer
      // this.dismiss()
    }
  },
  mounted() {
    setTimeout(() => (this.isActive = true), 500)
    // setTimeout(this.dismiss, 6000)
  }
}
</script>
